import {
  INSURANCE_TYPE_ALIAS,
  INSURANCE_TYPES_ICONS_V2,
} from 'constants/insurance';
import { isLifeReferral } from './marketScan';
import { MARKET_SCAN_AVERAGE_SAVINGS } from 'constants/marketScan';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';

const getSubtitle = (policyType: string) => {
  switch (policyType) {
    case INSURANCE_TYPES_NAMES.PET:
      return 'Exclusive offer';
    case INSURANCE_TYPES_NAMES.TRAVEL:
      return 'Quick quote';
    default:
      if (isLifeReferral(policyType)) {
        return 'Compare options';
      }
      const savings = MARKET_SCAN_AVERAGE_SAVINGS[policyType];
      return savings ? `Avg. savings ${savings}` : '';
  }
};

export const getPolicyTypesToShow = (selectedPolicies: string[] = []) => {
  const otherSelected =
    selectedPolicies.find(
      (p) =>
        ![
          INSURANCE_TYPES_NAMES.VEHICLE,
          INSURANCE_TYPES_NAMES.HOME_CONTENTS,
          INSURANCE_TYPES_NAMES.HOME,
          INSURANCE_TYPES_NAMES.CONTENT,
        ].includes(p),
    ) || INSURANCE_TYPES_NAMES.HEALTH;

  return [
    {
      key: INSURANCE_TYPES_NAMES.VEHICLE,
      title: INSURANCE_TYPES_NAMES.VEHICLE,
      subtitle: `Avg. savings ${MARKET_SCAN_AVERAGE_SAVINGS[INSURANCE_TYPES_NAMES.VEHICLE]
        }`,
      image: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.VEHICLE],
    },
    {
      key: INSURANCE_TYPES_NAMES.HOME_CONTENTS,
      title: INSURANCE_TYPES_NAMES.HOME_CONTENTS,
      subtitle: `Avg. savings ${MARKET_SCAN_AVERAGE_SAVINGS[INSURANCE_TYPES_NAMES.HOME_CONTENTS]
        }`,
      image: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.HOME_CONTENTS],
    },
    {
      key: otherSelected,
      title:
        otherSelected === INSURANCE_TYPES_NAMES.LIFE
          ? 'Life insurance'
          : INSURANCE_TYPE_ALIAS[otherSelected] || otherSelected,
      subtitle: getSubtitle(otherSelected),
      image: INSURANCE_TYPES_ICONS_V2[otherSelected],
    },
  ];
};

export const policyTypesToShow = [
  {
    key: INSURANCE_TYPES_NAMES.VEHICLE,
    title: INSURANCE_TYPES_NAMES.VEHICLE,
    subtitle: MARKET_SCAN_AVERAGE_SAVINGS[INSURANCE_TYPES_NAMES.VEHICLE],
    image: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.VEHICLE],
  },
  {
    key: INSURANCE_TYPES_NAMES.HOME_CONTENTS,
    title: INSURANCE_TYPES_NAMES.HOME_CONTENTS,
    subtitle: MARKET_SCAN_AVERAGE_SAVINGS[INSURANCE_TYPES_NAMES.HOME_CONTENTS],
    image: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.HOME_CONTENTS],
  },
  {
    key: INSURANCE_TYPES_NAMES.CONTENT,
    title: INSURANCE_TYPES_NAMES.CONTENT,
    subtitle: MARKET_SCAN_AVERAGE_SAVINGS[INSURANCE_TYPES_NAMES.CONTENT],
    image: INSURANCE_TYPES_ICONS_V2[INSURANCE_TYPES_NAMES.CONTENT],
  },
];

